// React, Next
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import Link from 'next/link'

// MUI
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

// Custom
import Section from '@/components/sections/Section'
import { translateHref } from '@/assets/functions/links'
import { GlobalContext } from 'context/GlobalContextProvider'

// Config
import nextI18nextConfig from 'next-i18next.config'

// Style
import themeColors from 'assets/theme/colors'
import breakpoints from 'assets/theme/breakpoints'
import { getFontH3 } from '@/assets/theme/fonts'

export default function CtaSection() {
  const { t } = useTranslation('technology')
  const { screenDimensions } = useContext(GlobalContext)

  const router = useRouter()
  const currentLocale =
    router.query.locale || nextI18nextConfig.i18n.defaultLocale

  const stacked = screenDimensions.width < breakpoints.desktopToMobile

  const getContent = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: stacked ? 'column' : 'row',
        alignItems: stacked ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        gap: '1.75rem',
        width: '100%'
      }}
    >
      <Typography
        variant="h2"
        component="h2"
        fontSize={getFontH3()}
        sx={{
          fontWeight: 700,
          lineHeight: 1.25,
          color: themeColors.gray.dark
        }}
      >
        {t('cta.title')}
      </Typography>

      <Link
        href={translateHref(currentLocale, 'contact')}
        style={{ textDecoration: 'none', flexShrink: 0 }}
      >
        <Button
          variant="contained"
          endIcon={<ArrowForwardIosIcon sx={{ transform: 'scale(0.7)' }} />}
          sx={{
            background: themeColors.success.main,
            borderRadius: '4px',
            padding: '0.75rem 1.5rem',
            fontWeight: 600,
            letterSpacing: '0.03em',
            boxShadow: 'none',
            '&:hover': {
              background: themeColors.success.darker,
              boxShadow: 'none'
            }
          }}
        >
          {t('cta.button')}
        </Button>
      </Link>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.background}
      paddingTop="5rem"
      paddingBottom="6rem"
      content={getContent()}
    />
  )
}
